export default {
    navigationBarTitleText: '项目款项',
  };
  